module.exports = __webpack_public_path__ + "static/SM1-0a2eb1f857d5bd75450ffe71ba3a1bcd.jpg";